export default "__VITE_ASSET__BMmlgk3j__"